<div *transloco="let t; read: 'status-progress-view'" class="status-progress-view__container">
  <div class="status-progress-view__header">
    <div class="status-progress-view__title-container">
      <span class="status-progress-view__title">{{
        t('title', { completed: completedCount })
      }}</span>

      <span class="status-progress-view__subtitle">{{
        t('subtitle', { total: totalCount, name: mode === 'item' ? t('action-items') : t('tasks') })
      }}</span>
    </div>

    <div #chart class="status-progress-view__chart"></div>
  </div>

  <div class="status-progress-view__status-list">
    <div class="status-progress-view__status-row">
      <div class="status-progress-view__status-header">
        <span class="status-progress-view__status-title">{{
          t('not-started', { value: notStartedCount, total: totalCount })
        }}</span>

        <span class="status-progress-view__status-metric">{{ notStartedPct }}%</span>
      </div>

      <app-lex-progress-bar
        [value]="notStartedPct"
        [color]="constants.NOT_STARTED_COLOR"
      ></app-lex-progress-bar>
    </div>

    <div class="status-progress-view__status-row">
      <div class="status-progress-view__status-header">
        <span class="status-progress-view__status-title">{{
          t('in-progress', { value: inProgressCount, total: totalCount })
        }}</span>

        <span class="status-progress-view__status-metric">{{ inProgressPct }}%</span>
      </div>

      <app-lex-progress-bar
        [value]="inProgressPct"
        [color]="constants.IN_PROGRESS_COLOR"
      ></app-lex-progress-bar>
    </div>

    <div class="status-progress-view__status-row">
      <div class="status-progress-view__status-header">
        <span class="status-progress-view__status-title">{{
          t('completed', { value: completedCount, total: totalCount })
        }}</span>

        <span class="status-progress-view__status-metric">{{ completedPct }}%</span>
      </div>

      <app-lex-progress-bar
        [value]="completedPct"
        [color]="constants.COMPLETED_COLOR"
      ></app-lex-progress-bar>
    </div>
  </div>
</div>
